import React, { createContext } from 'react';
import { ContextValue, State } from './type';

export const initialState: State = {
    expiryInSecond: 3600,
    promptExpiryInSecond: 30,
    /** Minimum ms between refresh attempts when user is active (5 min). */
    refreshCooldownMilliseconds: 5 * 60 * 1000,
    /** Throttle for onAction so we don't run on every mousemove (1 min). */
    throttleInMilliseconds: 60 * 1000,
};

const ConfigContext = createContext<ContextValue>({
    state: initialState,
    dispatch: () => {}
});

export default ConfigContext
